import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import Sidebar from './Sidebar';
import HeaderBar from './HeaderBar';

export default function Layout() {
  // Drawer state for mobile (`< md`). On `md+` the sidebar is static and
  // this flag is ignored by the Sidebar component.
  const [navOpen, setNavOpen] = useState(false);

  return (
    // pl/pr-safe pull the layout back inside iOS landscape notches; pb-safe
    // protects the bottom-of-page content from the iPhone home indicator.
    <div className="flex h-full pl-safe pr-safe">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="flex-1 flex flex-col min-w-0">
        <HeaderBar onMenuClick={() => setNavOpen(true)} />
        <div className="flex-1 overflow-auto p-4 sm:p-6 pb-safe">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
